export default __webpack_public_path__ + "static/media/sothebys.af3bc004.svg";